export enum TabIndex {
  RecentChats,
  Projects,
  Assets,
  Tasks,
  Requirements,
  Files
}